module.exports = __webpack_public_path__ + "img/0706-酒类-下-02.96cc7677.png";